// Notes:
// - Add SPA sub-routes here as needed.
// - Don't forget to add to the routes[] below.
// - Make sure to open up the sub-routes in /config/routes.php as well.
// - IMPORTANT: See the front-end doc for VueRouter guidelines!

import Vue from 'vue'
import VueRouter from 'vue-router'
import VueScrollTo from 'vue-scrollto'

Vue.use(VueRouter)

// Sub-routes
import BuyflowRoutes from '~/Buyflow/routes'
import RemoteControlRoutes from '~/OrderRemoteControl/routes'
import ActivateWifiRoutes from '~/ActivateWifi/routes'
import EquipmentSwapRoutes from '~/EquipmentSwap/routes'
export default new VueRouter({
    mode: 'history',
    routes: [
        BuyflowRoutes,
        RemoteControlRoutes,
        ActivateWifiRoutes,
        EquipmentSwapRoutes,
    ],

    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            setTimeout(() => {
                VueScrollTo.scrollTo(to.hash, 0);
                return { selector: to.hash }
            }, 500)

        } else if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 }
        }
    }
})
